module.exports = __webpack_public_path__ + "img/sl_image4.6f5fd292.png";